import SearchDropDown from '../SearchDropDown/SearchDropDown';
import _ from 'lodash';
import './EmployeeBar.css';
import { useEffect, useState,useContext } from 'react';
import {Employee_level_url} from '../../Essentials/variables';
import useAccess from '../../Page/LoginPage/useAccess';
import { getPreLevel } from '../../Essentials/common_fn';
import {AppContext} from '../../Context';
import { BaseURL } from '../../Essentials/variables';
import axios from 'axios'
// const EmployeeBarOptions = ['Zonal Office','Regional Office','Dealers'];
// const dropDownOptions = ['ABC', 'DEF', 'GHI', 'LMNOP'];
// const EmployeeBarComponents = EmployeeBarOptions.map((item)=>{
//     return <SearchDropDown placeholder={item} key={item} selection = {selection} options = {dropDownOptions}/>
// });

async function getData(params){
    var url = Employee_level_url + '/' + params.join('/')
    let data = await fetch(url);
    console.log('DATA jo galat hai',data.json())
    return  data.json();
}
let Token=localStorage.getItem('token')
// CENTRAL	CENTRAL 1
// EAST	EAST 3
// SOUTH	SOUTH 3
// CENTRAL	CENTRAL 4
// WEST	WEST 1
// SOUTH	SOUTH 2
// WEST	WEST 3
// EAST	EAST 4
// EAST	EAST 1
// SOUTH	SOUTH 4
const allOptions = {
    'zo' : ['NORTH','SOUTH','EAST','WEST','CENTRAL','SOUTH EAST'],
    'ro' : {
        'CENTRAL' : ['CENTRAL 1','CENTRAL 2','CENTRAL 3','CENTRAL 4'],
        'NORTH' : ['NORTH 1','NORTH 2','NORTH 3','NORTH 4'],
        'EAST' : ['EAST 1','EAST 2','EAST 3'],
        'WEST' : ['WEST 1','WEST 2','WEST 3'],
        'SOUTH' : ['SOUTH 1','SOUTH 2','SOUTH 3'],
        'SOUTH EAST' : ['SOUTH EAST 1','SOUTH EAST 2']
    },
    'dealer' : []
}
export default function EmployeeBar(){
    const {stateData ,setStateData,loader,setLoader,dealersData,setDealersData,Dealerresult,setDealerresult,selectedOption,setSelectedOption,options,setOptions} = useContext(AppContext);
    // const [options,setOptions] = useState({'zo' : [],'ro' : [],'dealer' : []});
    const {getUserInfo} = useAccess();
    // const [selectedOption,setSelectedOption] = useState({'zo' : '','ro' : '','dealer' : ''});
    const [dealersResponse,setDealersResponse] = useState([]);
    // const { stateData, setStateData } = useContext(AppContext);
   useEffect(()=>{
    var level = getUserInfo()['level'];
    // var level = 'dealer';
    var region = _.uniq(getUserInfo()['AccessIn'].map((item)=>  item['Region']));
    // var region ='Jharkhand';
    console.log('Yahan level hai',level)
    switch(level){
        
        case 'HO':{
            var dealers = [];
            // Dealerresult.forEach((x)=>{
            //     dealers.push(x.dealer_name);
            //     console.log(x.dealer_name);

            // })
            console.log("done-1");
            // console.log(dealersData);
            console.log(allOptions['zo']);
            setOptions({...options,'zo':allOptions['zo'],'ro':['All regions'],'dealer':['All Dealers']});
            break;
        }

        // case 'Zone':{
        //     let roOptions = _.flatten(_.values(allOptions['ro']));
        //     //console.log(roOptions);
        //     setOptions({...options,'zo':[_.first(region).substring(0, _.first(region).indexOf(' '))],'ro':region});
        //     break;
        // }
        case 'Zone':{
            var dealers = [];
            var res = [];
            let roOptions = _.flatten(_.values(allOptions['ro']));
            // getData(['dealer',region]).then((d)=>{
            //     d?.forEach((item)=>{
            //         dealers.push(item["Dealer"]);
            //         res.push(item);
            //     });
                
                console.log("done-2");
                // dealersData.forEach((x)=>{
                //     dealers.push(x.dealer_name)
                // })
                console.log('zo mein jo aa rhaa',_.first(region).substring(0, _.first(region).indexOf(' ')))
                setOptions({...options,'zo':[_.first(region).substring(0, _.first(region).indexOf(' '))],'ro':region,'dealer': _.uniq(dealers)});
                setDealersResponse(res);
            // });
            break;
        }

        case 'Region':{
            var dealers = [];
            var res = [];
            // getData(['dealer',region]).then((d)=>{
            //     d.forEach((item)=>{
            //         dealers.push(item["Dealer"]);
            //         res.push(item);
            //     });
                /////
                console.log("done-3");
                setOptions({...options,'zo':[_.first(region).substring(0, _.first(region).indexOf(' '))],'ro':region,'dealer': _.uniq(dealers)});
                setDealersResponse(res);
            // });
            if(region){

                axios({
                    method:'GET',
                    headers:{
                        "x-access-token":localStorage.getItem('token'),
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Frame-Options': 'DENY',
                        'Content-Security-Policy': "frame-ancestors 'none'",
                        'Feature-Policy': "frame-ancestors 'none'"
                    },
                    withCredentials:false,
                    url:BaseURL+'getdealers/'+ _.replace(region,/ /g,'')
                    }).then((res)=>{
                      setDealerresult(res.data)
                      // Dealerresult=res.data;
                    //    console.log(Dealerresult);
                    })
                    .then(()=>{
                        console.log(Dealerresult);
                    })
            }
            break;
        }       
            
            
        case 'Dealer':
            setOptions({...options,'zo':['-'],'ro':['-'],'dealer':[getUserInfo()['Name']]});    
            break;
        }
   },[]);
//stateData.selected
// useEffect(()=>{
//     setDealersData('employee')
//     if(stateData.selected.State!='' && stateData.selected.District=='' && stateData.selected.Sub_District==''){
    //   axios({
    //     method:'GET',
    //     withCredentials:false,
    //     url:BaseURL+'getdealers/'+stateData.selected.State// +'/'+stateData.selected.District+'/'+stateData.selected.Sub_District
    //     }).then((res)=>{
    //       setDealerresult(res.data)
    //       // Dealerresult=res.data;
    //       //  console.log(Dealerresult);
    //     })
    //   console.log("Call API here");
    // }
//     // console.log(stateData.selected);
//   },[stateData.selected])
const userDealerEmployee = JSON.parse(localStorage.getItem("userInfo"));
// console.log("Type check",userDealerEmployee?.type);
function selection(type,value){
    console.log("abhi",type,value);
    if(type==='Regional Office'){
        console.log("call API");
       
    }
    switch(type){
        case 'Zonal Office':
            {
                setSelectedOption({...selectedOption,'zo' : value});
                console.log('Zonal office value',value)
                setStateData({...stateData,'optionSelection' : {'level':'zo','option':value}});
                var level = getUserInfo()['level'];
                if(level === 'HO'){
                    setOptions({...options,'ro':allOptions['ro'][value]});
                }
                console.log("stateData",stateData);
                console.log("selectedOption",selectedOption);
                break;
            }
        case 'Regional Office':
            {
                // console.log("hua hai");
                setSelectedOption({...selectedOption,'ro' : value});
                var dealers = [];
                var res = [];
                if(value){
                    axios({
                        method:'GET',
                        headers:{
                        "x-access-token":localStorage.getItem('token'),
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Frame-Options': 'DENY',
                        'Content-Security-Policy': "frame-ancestors 'none'",
                        'Feature-Policy': "frame-ancestors 'none'"
                        },
                        withCredentials:false,
                        url:BaseURL+'getdealers/'+ _.replace(value,/ /g,'')
                        }).then((res)=>{
                          setDealerresult(res.data)
                          // Dealerresult=res.data;
                           
                        })
                        .then(()=>{
                            console.log(Dealerresult);
                        })
                }
                // getData(['dealer',value]).then((d)=>{
                //     d.forEach((item)=>{
                //         dealers.push(item["Dealer"]);
                //         res.push(item);
                //         //console.log(item);
                //     });
                //     setOptions({...options,'dealer': _.uniq(dealers)});
                //     // console.log( _.uniq(dealers));
                //     setDealersResponse(res);
                // });
                
                
                setStateData({...stateData,'optionSelection' : {'level':'ro','option':value}});
                break;
            }
        case 'Dealers':
            {
                setSelectedOption({...selectedOption,'dealer' : value});
                if(selectedOption['ro'] !== "-" && selectedOption['ro'] !== "ALL"){
                    setStateData({...stateData,'optionSelection' : {'level':'dealer','option':value,'dealers':dealersResponse,'prevOption':selectedOption['ro']}});
                }else{
                    setStateData({...stateData,'optionSelection' : {'level':'dealer','option':value,'dealers':dealersResponse,'prevOption':selectedOption['ro']}});
                }
                break;

            }
        }
        // console.log(options);
}
const handleDealerdropdownClick = () =>{
    console.log('axios request');
}
const handleDealerdropdownChange = () =>{
    console.log(selectedOption['zo']);
    console.log(selectedOption['ro']);
}


    return (
        <div>
            <div className="employee-bar">
                {/* {EmployeeBarComponents} */}
                <div className='zo-div'><SearchDropDown placeholder='Zonal Office' id='empbr' selection={selection} options={options["zo"]} /></div>
                <div className='ro-div'><SearchDropDown placeholder='Regional Office' id='empbr' selection={selection} options={options["ro"]} /></div>
                {/* <SearchDropDown placeholder='Dealers'  id = 'empbr'  selection = {selection} options = {options["dealer"]}/> */}
                {<div className="dealer-select-div">
                    {/* <select onChange={(e)=>{ setDealersData(e.target.value) }}  id="countries" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-2.5 py-1 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"> */}
                    {userDealerEmployee?.type == "employee" && <select onChange={(e) => { setDealersData(e.target.value) }} id="countries" className="dealer-select-select">

                        <option className='' key="employee" value="employee">Select Dealer</option>
                        {Dealerresult.map((res) => (
                            <option key={res.parent_group} value={res.parent_group}>
                                {`${res.dealer_name}`}
                            </option>
                        ))}
                    </select>}

                    {userDealerEmployee?.type !== "employee" && <select onChange={(e) => { setDealersData(e.target.value) }} id="countries" className="dealer-select-select">
                        <option className='' key="employee" value="employee">{userDealerEmployee?.type}</option>
                    </select>}
                </div>}

            </div>
            <div className='horizontal-line'></div>
        </div>
    );
}